export default __webpack_public_path__ + "static/media/figma.d4d4de93.png";